import styled from 'styled-components';

export const ConfirmationPageWrapper = styled.div`
    margin: -10% 2% 0 2%;
`;
